<template>
  <div :class="`odometer--container odometer--${animated ? 'active' : ''}`">
    <div class="odometer-custom">
      <i-odometer format="( ddd),dd" :value="num"></i-odometer>
      ₽
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IOdometer from 'vue-odometer';

export default {
  props: ['word', 'year_total', 'delay', 'speed'],

  computed: mapGetters({
    firstVisitAnimation: 'firstVisitAnimation',
    animation: 'animation',
    loaded: 'loaded',
    theme: 'theme',
  }),

  components: {
    IOdometer,
  },

  data() {
    return {
      animated: true,
      today: 0,
      timer: null,
      num: 999999,
    };
  },

  mounted() {
    // current year
    const currentYear = new Date().getFullYear();
    const year = new Date(currentYear, 0, 0).getTime();

    // today in seconds
    const todaySeconds = (new Date().getTime() - year) / 1000;

    // today in minutes
    this.today = todaySeconds / 60;
    this.startCount();
  },

  watch: {
    theme() {
      clearInterval(this.timer);
      this.animated = false;
      this.num = 0;
      this.startCount();
      setTimeout(() => {
        this.animated = true;
      }, 1200);
    },
    firstVisitAnimation() {
      this.updateCount();
    },
  },

  methods: {
    startCount() {
      if (this.year_total > 0) {
        // 525600 minutes in a year
        this.step = this.year_total / 525600;

        this.num = Math.floor(this.step * (this.today));
        this.updateCount();
        this.timer = setInterval(() => {
          this.updateCount();
        }, 2000);
      }
    },

    updateCount() {
      if (!this.firstVisitAnimation || !this.loaded) {
        this.num += Math.floor(this.step / 60);
      }
    },
  },
};
</script>

<style scoped>
  .odometer {
    &--container{
      white-space: nowrap;
      position: relative;
      overflow: hidden;
      min-width: 370px;
      height: 54px;
      margin: 0;

      @media (max-width: $mediaIpad) {
        font-size: 85%;
        height: 33px;
        top: 8px;
      }

      @media (max-width: $mediaMini) {
        font-size: 120%;
      }

      .odometer-custom {
        transform: translate3d(0,60px,0);
        .in-viewport &{
          transition: 1s ease-in-out all;
        }
      }

      .odometer.odometer-theme-default{
        font-family: 'Direct', Helvetica, Arial, sans-serif;
        white-space: nowrap;
      }

    }

    &--active{
      .odometer-custom {
        transform: none;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/TextOdometer.vue